import React, { useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import moment from 'moment-timezone';

const CurrentTime = ({ timezone }: { timezone?: string }) => {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return <Typography variant="h5">{(timezone ? moment(time).tz(timezone) : moment(time)).format('HH:mm')}</Typography>;
};

export default CurrentTime;
